export default {"src":"/_next/static/media/calendly-confirmation-thank-you.19543c2f.svg","height":408,"width":790,"blurWidth":0,"blurHeight":0};